import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowDown, FiCheckCircle} = FiIcons;

function Hero() {
  const scrollToPrograms = () =>
    document.getElementById('programs')?.scrollIntoView({behavior: 'smooth'});

  return (
    <header className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="eyebrow">Florida HVAC Training Directory</p>
        <h1 className="hero-title">Compare HVAC Schools in Florida</h1>
        <p className="hero-copy">
          Build the technical knowledge and hands-on confidence needed to
          maintain the systems that keep Florida homes, businesses, hospitals,
          and industrial facilities comfortable.
        </p>
        <button className="primary-button" onClick={scrollToPrograms}>
          Explore Florida HVAC Programs
          <SafeIcon icon={FiArrowDown} aria-hidden="true" />
        </button>
        <p className="trust-line">
          <SafeIcon icon={FiCheckCircle} aria-hidden="true" />
          Independent comparisons covering formats, credentials, skills, and
          career readiness
        </p>
      </div>
    </header>
  );
}

export default Hero;